export default "__VITE_ASSET__3a89780e__"